import {Component} from 'react';
import {Preloader, Hero, Header, Content} from "../../components";

import closeIcon from './../../resources/icons/close.svg';

import bluePic from './../../resources/blue.png';
import titlePic from './../../resources/title.png';
import posterPic from './../../resources/poster.png';
import topPic from './../../resources/top.png';
import left1Pic from './../../resources/left-1.png';
import left2Pic from './../../resources/left-2.png';
import left3Pic from './../../resources/left-3.png';
import left4Pic from './../../resources/left-4.png';
import right1Pic from './../../resources/right-1.png';
import right2Pic from './../../resources/right-2.png';
import right3Pic from './../../resources/right-3.png';
import frontPic from './../../resources/front.png';
import cardPic from './../../resources/card.png';
import borderPic from './../../resources/border.png';
import yellowVk from './../../resources/icons/yellow-vk.svg';
import yellowTg from './../../resources/icons/yellow-tg.svg';
import yellowOk from './../../resources/icons/yellow-ok.svg';
import stickersPic from './../../resources/stickers.png';
import premierIcon from './../../resources/icons/premier.svg';
import copyIcon from './../../resources/icons/copy.svg';

export class App extends Component {
    state = {
        loading: true,
        start: true
    }

    componentDidMount() {
        let images = [premierIcon, copyIcon, closeIcon, bluePic, titlePic, topPic, posterPic, left1Pic, left2Pic, left3Pic, left4Pic, right1Pic, right2Pic, right3Pic, frontPic, cardPic, borderPic, yellowVk, yellowTg, yellowOk, stickersPic];
        let promises = [];

        images.forEach(image => {
            promises.push(new Promise((resolve, reject) => {
                const newImage = new Image();

                newImage.addEventListener("load", function () {
                    resolve();
                });

                newImage.src = image;
                window[image] = newImage;
            }));
        });

        Promise.all(promises).then(() => {
            this.setState(({loading}) => ({
                loading: !loading
            }));

            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });
    }

    render() {
        const content = () => {
            return (
                <>
                    {this.state.start ? <Hero handler={() => this.setState({start: false})}/> : <Content/>}
                </>
            )
        }

        return (
            <div className="wrapper">
                <Header/>
                {this.state.loading ? <Preloader/> : content()}
            </div>
        );
    }
}